'use client'

import { EyeIcon, XIcon } from '@phosphor-icons/react'

export const DraftModeIndicator = ({ isEnabled = false }: { isEnabled: boolean }) => {
  if (!isEnabled) return null

  return (
    <div className="fixed right-4 top-2 z-50">
      <div className="flex items-center space-x-2 rounded-lg bg-orange-700 px-4 py-2 text-sm font-medium text-white shadow-lg">
        <EyeIcon size={16} />
        <span>Draft Mode</span>
        <button
          onClick={() => {
            window.location.href = `/api/disable-draft?returnUrl=${encodeURIComponent(window.location.pathname)}`
          }}
          className="ml-2 rounded p-1 transition-colors hover:bg-orange-600"
          title="Disable Draft Mode"
        >
          <XIcon size={14} />
        </button>
      </div>
    </div>
  )
}
